import type { DashboardMode, FilterPresetSurface } from "@nexus/contracts";

const KEY = "nexus_active_filter_preset";

type StorageKey = `${FilterPresetSurface}:${DashboardMode}`;
type ActivePresetMap = Partial<Record<StorageKey, string>>;

function toStorageKey(surface: FilterPresetSurface, mode: DashboardMode): StorageKey {
  return `${surface}:${mode}`;
}

function readMap(): ActivePresetMap {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as ActivePresetMap;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(map: ActivePresetMap): void {
  try {
    if (Object.keys(map).length === 0) {
      localStorage.removeItem(KEY);
      return;
    }
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* incognito / quota exceeded */
  }
}

export function readActivePresetId(
  surface: FilterPresetSurface,
  mode: DashboardMode,
): string | null {
  const id = readMap()[toStorageKey(surface, mode)];
  return typeof id === "string" && id.length > 0 ? id : null;
}

export function writeActivePresetId(
  surface: FilterPresetSurface,
  mode: DashboardMode,
  id: string | null,
): void {
  const map = readMap();
  const key = toStorageKey(surface, mode);
  if (id === null) {
    delete map[key];
  } else {
    map[key] = id;
  }
  writeMap(map);
}
